export default __webpack_public_path__ + "static/1-1--dce22c5f4673d8cc9796feda80cdbcff.png";